import React from 'react'
import { Box } from '@mantine/core'

interface RightFloatingProps {
  children?: React.ReactNode
  className?: string
}

export default function RightFloating({ children, className }: RightFloatingProps) {
  return (
    <Box data-export-hidden className={`fixed right-0 top-[40%] z-[999] ${className || ''}`}>
      {children}
    </Box>
  )
}
